import store from 'store';
import sellerStore from 'store/indexSeller';
import {isCurrentAppSeller} from 'utils/appTypeState';

const SEGMENT_SEPARATOR = ' - ';


class DynamicTitle {
  constructor () {
    // this is singleton
    if (DynamicTitle._instance) {
      return DynamicTitle._instance;
    }
    DynamicTitle._instance = this;

    this.segments = [];
    this.entityName = '';
  }

  get appNameSegment () {
    if (isCurrentAppSeller()) {
      return sellerStore.getters['sellerCommon/appName'];
    }

    return store.getters['common/appName'];
  }

  updateAppTitle () {
    const buildSegments = [
      this.entityName,
      ...this.segments,
      this.appNameSegment
    ];
    const filtered = buildSegments.filter(s => Boolean(s));
    document.title = filtered.join(SEGMENT_SEPARATOR);
  }

  clearSegments () {
    this.segments = [];
  }

  addSegment (segmentName) {
    try {
      const name = typeof segmentName === 'function' ? segmentName() : segmentName;
      this.segments.push(name);
    } catch (e) {
      console.error('Error building route segments', e);
    }
  }

  updateRouteName (routesPath) {
    this.entityName = '';
    this.clearSegments();

    const routesMeta = routesPath.map(r => r.meta);
    const routeNames = routesMeta.map(m => m.routeName).filter(i => Boolean(i));

    // need to reverse routes because last route in this list is current route, other are current route parents
    routeNames.reverse();

    for (const r of routeNames) {
      if (r.segmentName) {
        this.addSegment(r.segmentName);
        continue;
      }
      if (r.name) {
        this.clearSegments();
        this.addSegment(r.name);
        break;
      }
      console.warn('[DynamicTitle] wrong routeName configuration for current route!');
    }
    this.updateAppTitle();
  }

  setEntityName (name) {
    this.entityName = typeof name === 'function' ? name() : name;
    this.updateAppTitle();
  }
}


export default new DynamicTitle();
